import { Roles } from "../shared/authentication/auth.service";

// COMMONS

const headingMain = {
    text: 'Main Menu',
    heading: true,
    translate: 'menu.HEADINGMAIN'
};

// UBER

const Organizations = {
    text: 'Organizations',
    roles: [Roles.UBERADMIN],
    link: '/uberadmin/organizations',
    image: '/assets/img/company.svg',
    active_image: '/assets/img/company.svg',
    translate: 'menu.ORGANIZATIONS',
    submenu: [
        {
            text: 'New',
            link: '/uberadmin/organizations/new',
            translate: 'menu.ORGANIZATIONS_NEW'
        },
        {
            text: 'Import',
            link: '/uberadmin/organizations/import',
            translate: 'menu.ORGANIZATIONS_IMPORT'
        },
        {
            text: 'Listing',
            link: '/uberadmin/organizations/listing',
            translate: 'menu.ORGANIZATIONS_LISTING'
        }
    ]
};
const UberConfig = {
    text: 'Configuration',
    roles: [Roles.UBERADMIN],
    image: '/assets/img/settings-cogwheel-button.svg',
    active_image: '/assets/img/settings-cogwheel-button.svg',
    translate: 'menu.CONFIGURATION',
    submenu:[
        {
            text: 'Beacon',
            link: 'configuration/beacon',
            translate: 'menu.BEACON'
        },
        {
            text: 'Change password',
            link: 'configuration/change_password',
            translate: 'menu.CHANGE_PASSWORD'
        }
    ]
};

// ADMIN

const Dashboard = {
    roles: [Roles.ADMIN, Roles.WORK_MANAGER],
    text: 'Dashboard',
    link: '/admin/dashboard',
    image: '/assets/img/dashboard.svg',
    active_image: '/assets/img/dashboard.svg',
    translate: 'menu.DASHBOARD'
};

const CompaniesAdmin = {
    roles: [Roles.ADMIN],
    text: 'Companies',
    link: '/admin/companies',
    image: '/assets/img/company.svg',
    active_image: '/assets/img/company.svg',
    translate: 'menu.COMPANIES',
    submenu: [
        {
            text: 'New',
            link: '/admin/companies/new',
            translate: 'menu.COMPANIES_NEW'
        },
        {
            text: 'Import',
            link: '/admin/companies/import',
            translate: 'menu.COMPANIES_IMPORT'
        },
        {
            text: 'Listing',
            link: '/admin/companies/listing',
            translate: 'menu.COMPANIES_LISTING'
        }
    ]
}

const UsersAdmin = {
    roles: [Roles.ADMIN],
    text: 'Users',
    link: '/admin/users',
    image: '/assets/img/users-social-symbol.svg',
    active_image: '/assets/img/users-social-symbol.svg',
    translate: 'menu.USERS',
    submenu: [
        {
            text: 'New',
            link: '/admin/users/new',
            translate: 'menu.USERS_NEW'
        },
        {
            text: 'Import',
            link: '/admin/users/import',
            translate: 'menu.USERS_IMPORT'
        },
        {
            text: 'Listing',
            link: '/admin/users/listing',
            translate: 'menu.USERS_LISTING'
        }
    ]
};

const ProtectiveEquipmentAdmin = {
    roles: [Roles.ADMIN],
    text: 'Protective Equipment',
    link: '/admin/equipment',
    image: '/assets/img/helmet.svg',
    active_image: '/assets/img/helmet.svg',
    translate: 'menu.PROTECTIVE_EQUIPMENT',
    submenu: [
        {
            text: 'New',
            link: '/admin/equipment/new',
            translate: 'menu.EQUIPMENT_NEW'
        },
        {
            text: 'Import',
            link: '/admin/equipment/import',
            translate: 'menu.EQUIPMENT_IMPORT'
        },
        {
            text: 'Listing',
            link: '/admin/equipment/listing',
            translate: 'menu.EQUIPMENT_LISTING'
        }
    ]
};

const WorkOrders = {
    roles: [Roles.ADMIN, Roles.WORK_MANAGER],
    text: 'Work Orders',
    link: '/admin/workorders',
    image: '/assets/img/clipboard.svg',
    active_image: '/assets/img/clipboard.svg',
    translate: 'menu.WORK_ORDERS',
    submenu: [
        {
            text: 'New',
            link: '/admin/workorders/new',
            translate: 'menu.WORK_ORDERS_NEW'
        },
        {
            text: 'Listing',
            link: '/admin/workorders/listing',
            translate: 'menu.WORK_ORDERS_LISTING'
        }
    ]
};


// Work Manager

const CompaniesWM = {
    roles: [Roles.WORK_MANAGER],
    text: 'Companies',
    link: '/admin/companies/listing',
    image: '/assets/img/company.svg',
    active_image: '/assets/img/company.svg',
    translate: 'menu.COMPANIES'
}

const UsersWM = {
    roles: [Roles.WORK_MANAGER],
    text: 'Users',
    link: '/admin/users/listing',
    image: '/assets/img/users-social-symbol.svg',
    active_image: '/assets/img/users-social-symbol.svg',
    translate: 'menu.USERS'
};

const ProtectiveEquipmentWM = {
    roles: [Roles.WORK_MANAGER],
    text: 'Protective Equipment',
    link: '/admin/equipment/listing',
    image: '/assets/img/helmet.svg',
    active_image: '/assets/img/helmet.svg',
    translate: 'menu.PROTECTIVE_EQUIPMENT'
};

export const menu = [

    // uber
    headingMain,
    Organizations,
    UberConfig,

    Dashboard,
    CompaniesAdmin,
    CompaniesWM,
    UsersAdmin,
    UsersWM,
    ProtectiveEquipmentAdmin,
    ProtectiveEquipmentWM,
    WorkOrders,
];



// WEBPACK FOOTER //
// ./src/app/routes/menu.ts